import { Injectable } from '@angular/core';
import { ApiService } from './http/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  constructor(private apiClient: ApiService) {
  }

  getBranches(companyId: number): Promise<any[]> {
    return this.apiClient.getListCache(`/${companyId}/branches`, 'model', 1, true);
  }

  getBranchAll(companyId: number): any {
    return this.apiClient.get(`/${companyId}/branches/all`);
  }

  getBranch(companyId: number, branchId: number): any {
    return this.apiClient.get(`/${companyId}/branches/${branchId}`);
  }

  createBranch(companyId: number, data): any {
    return this.apiClient.post(`/${companyId}/branches`, data);
  }

  updateBranch(companyId: number, branchId: number, data): any {
    return this.apiClient.put(`/${companyId}/branches/${branchId}`, data);
  }

  deleteBranch(companyId: number, branchId: number): any {
    return this.apiClient.delete(`/${companyId}/branches/${branchId}`);
  }
}
